import React from 'react';
import { QuestionMarkCircleIcon, LinkIcon } from '@heroicons/react/24/solid'; // Import appropriate icons

const OptionsList = ({ selectedOption, onSelectOption }) => {
  // Navigation options for Q&A and URLs
  const options = [
    { name: 'Q&A', ref: 'qa', icon: QuestionMarkCircleIcon },
    { name: 'URLs', ref: 'urls', icon: LinkIcon },
  ];

  return (
    <div className="w-full bg-gray-100 p-4">
      <h2 className="text-lg font-bold mb-4">RAG sections</h2>
      <ul className="space-y-2">
        {options.map((option) => (
          <li
            key={option.ref}
            onClick={() => onSelectOption(option.ref)}
            className={`cursor-pointer p-2 rounded-lg shadow transition flex items-center space-x-2 ${
              selectedOption === option.ref
                ? 'bg-[#4790CF] text-white'
                : 'bg-white hover:bg-gray-200 text-gray-800'
            }`}
          >
            <option.icon className="h-6 w-6" aria-hidden="true" />
            <span>{option.name}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default OptionsList;
